import type { AppliedMetadata, ChatbotLogger } from '../types';

/**
 * Injects or updates metadata into the Applied Labs chatbot at runtime.
 */
export function setMetadata(
  metadata: AppliedMetadata,
  logger: ChatbotLogger | Console = console,
): void {
  try {
    window.applied?.setMetadata?.(metadata);
    logger.info?.(
      {
        type: 'client',
        context: 'Chatbot - setMetadata',
        message: 'Metadata injected',
        sessionId: undefined,
      },
      { metadata },
    );
  } catch (err) {
    logger.error?.(
      {
        type: 'client',
        context: 'Chatbot - setMetadata',
        message: 'Failed to set metadata',
        sessionId: undefined,
      },
      { error: err },
    );
  }
}
